const SHOP_DATA = [
  {
    category: "necklaces",
    products: [
      {
        id: 1,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 2,
        productName: "Menala Bracelet",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 3,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 4,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 5,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
    ],
  },
  {
    category: "bracelets",
    products: [
      {
        id: 6,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 7,
        productName: "Menala Bracelet",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 8,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 9,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
      {
        id: 10,
        productName: "Menala Necklace",
        productPrice: 320.0,
        stripePrice: "",
        stripeProduct: "",
        coverImage1Url:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        secondaryImageUrl:
          "https://i.etsystatic.com/17133212/r/il/485983/1763185039/il_794xN.1763185039_t219.jpg",
        displayImage:
          "https://images.shaneco.com/is/image/ShaneCo/necklace/570/Ruby-and-Diamond-Necklace-in-14k-Yellow-Gold-18-in._41080081_M.jpg",
        category: "Necklaces",
        collection: "Menala",
        metals: "Yellow Gold",
        description:
          "A new take on a classic tennis bracelet, the Vanguard Diamond Line Bracelet combines our signature Alchemy setting with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Vanguard Diamond Line Bracelet features 3 emerald-cut diamonds accompanied by 22 round, brilliant cut diamonds. The delicate chain design allows the bracelet to hand sophisticatedly on the wrist.  ",
      },
    ],
  },
];

export default SHOP_DATA;
